<template>
	<div class="usermana">
		<!-- 表头 -->
		<div class="button-group">
			<!-- 新建用户 -->
			<el-button type="primary" @click="createDialogVisible = true">新建</el-button>
			<!-- 刷新表单 -->
			<el-button type="success" @click="fetchCourseList">刷新</el-button>
			<!-- 删除选中用户 -->
			<el-button type="danger" :disabled="batchRemoveDisabled" @click="batchRemoveConfirm">删除选中</el-button>

			<div class="search">
				<el-select v-model="filter.closed" placeholder="请选择是否结课" size="large" @change="updateFilter" clearable>
					<el-option label="已结课" value="1"></el-option>
					<el-option label="未结课" value="0"></el-option>
				</el-select>
				<el-date-picker v-model="filter.semester" type="year" placeholder="请选择开课年份" size="large"
					style="width: 300px;" @change="updateFilter" />
			</div>
		</div>

		<!-- 表单 -->
		<el-config-provider :locale="zhCn">
			<el-table :row-class-name="rowClassName" ref="multipleTableRef" :data="courseList" highlight-current-row
				style="width: 100%; margin-top: 2vh; margin-bottom: 2vh" @selection-change="handleSelectionChange"
				:default-sort="{ prop: 'createDate', order: 'descending' }">

				<el-table-column type="selection" />
				<el-table-column label="课程号" prop="courseNum" :width="'auto'" />
				<el-table-column label="学期" prop="semester" :width="'auto'" />
				<el-table-column label="课程名称" prop="courseName" :width="'auto'" />
				<el-table-column v-if="false" label="开课日期" prop="createDate" :width="'auto'" :sortable="true" />
				<el-table-column label="结课状态" prop="closed" :formatter="formatClosed" :width="'auto'" />
				<el-table-column label="课程简介" prop="courseBrief" :width="'auto'">
					<template #default="scope">
						<el-button @click="enterBrief(scope.row)">简介</el-button>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="相关资料" width=300px>
					<template #default="scope">
						<el-button @click="getData(scope.row)">资料</el-button>
					</template>
				</el-table-column>

				<!-- 修改列 -->
				<el-table-column fixed="right" label="操作" width=300px>
					<template #default="scope">
						<el-button @click="modifyClass(scope.row)">修改课程</el-button>
						<el-button type="danger" @click="removeClass(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 页面分页功能 -->
			<el-pagination :page-size="limit" :total="total" v-model:current-page="page" @click="fetchCourseList" />
		</el-config-provider>

		<!-- 新建课程 -->
		<el-dialog title="输入信息" v-model="createDialogVisible" width="400px" :show-close="false">
			<el-form :model="createFormData">
				<el-form-item label="课程年份" prop="year" :rules="[{ required: true, message: '请选择年份' }]">
					<el-date-picker v-model="createFormData.year" type="year" placeholder="请选择" style="width: 100%"
						@change="updateSemester" />
				</el-form-item>

				<!-- 选择季节 -->
				<el-form-item label="课程季节" prop="season" :rules="[{ required: true, message: '请选择季节' }]">
					<el-select v-model="createFormData.season" placeholder="请选择" style="width: 100%"
						@change="updateSemester">
						<el-option label="春" value="春"></el-option>
						<el-option label="夏" value="夏"></el-option>
						<el-option label="秋" value="秋"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="课程号" prop="courseNum" :rules="[
					{
						required: true,
						message: '请输入课程号',
					},
				]">
					<el-input v-model="createFormData.courseNum" placeholder="请输入课程号" />
				</el-form-item>

				<el-form-item label="课程名称" prop="courseName" :rules="[
					{
						required: true,
						message: '请输入课程名称',
					},
				]">
					<el-input v-model="createFormData.courseName" placeholder="请输入课程名称" />
				</el-form-item>

				<el-form-item label="开课日期" prop="createDate" :rules="[
					{
						required: true,
						message: '请输入日期',
					},
				]">
					<el-date-picker v-model="createFormData.createDate" type="date" label="开课日期" placeholder="请输入"
						style="width: 100%" />
				</el-form-item>

				<el-form-item label="是否结课" prop="closed">
					<el-select v-model="createFormData.closed" placeholder="请选择" style="width: 100%">
						<el-option label="已结课" value="1"></el-option>
						<el-option label="未结课" value="0"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="备注" prop="comment">
					<el-input v-model="createFormData.comment" placeholder="请输入备注" />
				</el-form-item>
			</el-form>
			<span class="dialog-footer">
				<el-button @click="createDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitCreateForm">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 删除课程 -->
		<el-dialog title="确认删除选中课程" v-model="removeBatchDialogVisible" width="400px" :show-close="false">
			<span class="dialog-footer">
				<el-button @click="removeBatchDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="batchRemove">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="确认删除课程" v-model="removeDialogVisible" width="400px" :show-close="false">
			<el-form class="dialog-information">
				<p class="dialog-information-text">
					确认删除本课程嘛？
				</p>
			</el-form>
			<span class="dialog-footer">
				<el-button @click="removeDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitRemove">确 定</el-button>
			</span>
		</el-dialog>


		<!-- 修改课程 -->
		<el-dialog title="编辑信息" v-model="modifyDialogVisible" width="400px" :show-close="false">
			<el-form :model="modifyFormData">
				<el-form-item label="课程年份" prop="year">
					<el-date-picker v-model="modifyFormData.year" type="year" placeholder="请选择" style="width: 100%"
						@change="updateModifySemester" />
				</el-form-item>

				<!-- 选择季节 -->
				<el-form-item label="课程季节" prop="season">
					<el-select v-model="modifyFormData.season" placeholder="请选择" style="width: 100%"
						@change="updateModifySemester">
						<el-option label="春" value="春"></el-option>
						<el-option label="夏" value="夏"></el-option>
						<el-option label="秋" value="秋"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="课程号" prop="courseNum">
					<el-input v-model="modifyFormData.courseNum" placeholder="请输入课程号" />
				</el-form-item>

				<el-form-item label="课程名称" prop="courseName">
					<el-input v-model="modifyFormData.courseName" placeholder="请输入课程名称" />
				</el-form-item>

				<el-form-item label="开课日期" prop="createDate">
					<el-date-picker v-model="modifyFormData.createDate" type="date" label="开课日期" placeholder="请输入"
						style="width: 100%" />
				</el-form-item>

				<el-form-item label="是否结课" prop="closed">
					<el-select v-model="modifyFormData.closed" placeholder="请选择" style="width: 100%">
						<el-option label="已结课" value="1"></el-option>
						<el-option label="未结课" value="0"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="备注" prop="comment">
					<el-input v-model="modifyFormData.comment" placeholder="请输入备注" />
				</el-form-item>
			</el-form>
			<span class="dialog-footer">
				<el-button @click="modifyDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitModifyForm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { defineComponent, ref } from "vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import "@/styles/Common.css";

export default defineComponent({
	data() {
		return {
			courseList: [],
			placeholder: {
				namePlaceholder: "请输入课程名",
			},
			selectRemoveId: "",
			removeBatchDialogVisible: false,
			removeDialogVisible: false,
			createDialogVisible: false,
			modifyDialogVisible: false,
			resetVisible: false,
			createFormData: {
				year: null,   // 课程年份
				season: '',   // 课程季节
				semester: "",
				courseNum: "",
				courseName: "",
				createDate: "",
				comment: "",
				closed: "0",
			},
			modifyFormData: {
				id: "",
				year: null,   // 课程年份
				season: "",   // 课程季节
				semester: "",
				courseNum: "",
				courseName: "",
				createDate: "",
				comment: "",
				closed: "",
			},
			page: 1,
			limit: 9,
			filter: {
				semester: "",
				dateStart: "",
				dateEnd: "",
				closed: "",
			},

			total: 0,
			interval: null,
			multipleSelection: [],
			batchRemoveDisabled: true,
			zhCn,
		};
	},
	// 刷新页面
	async mounted() {
		this.fetchCourseList();
		this.interval = setInterval(() => {
			this.fetchCourseList();
		}, 5000);
	},
	unmounted() {
		clearInterval(this.interval);
	},
	setup() {
		const multipleTableRef = ref(null);
		const currentId = ref(null);
		const fileInput = ref(null);

		return {
			multipleTableRef,
			currentId,
			fileInput,
		};
	},
	methods: {
		// 表格背景
		rowClassName({ rowIndex }) {
			return rowIndex % 2 === 0 ? "even-row" : "odd-row";
		},

		// 格式化 "结课状态" 字段
		formatClosed(row, column, cellValue) {
			return cellValue === 1 ? '已结课' : '未结课';
		},

		updateFilter() {
			if (this.filter.semester) {
				// 选择年份后更新 dateStart 和 dateEnd
				const year = this.filter.semester.getFullYear();  // 获取选择的年份

				// 设置 filter.dateStart 为该年份的 1月1日
				this.filter.dateStart = `${year}-01-01`;

				// 设置 filter.dateEnd 为该年份的 12月31日
				this.filter.dateEnd = `${year}-12-31`;

				console.log('更新后的日期范围:', this.filter.dateStart, this.filter.dateEnd);
			} else {
				// 如果没有选择年份，清空 dateStart 和 dateEnd
				this.filter.dateStart = '';
				this.filter.dateEnd = '';
			}
			this.fetchCourseList();
		},
		//获取课程表单
		async fetchCourseList() {
			try {
				const response = await this.$axios.post("/api/course/list", {
					dateStart: this.filter.dateStart,
					dateEnd: this.filter.dateEnd,
					closed: this.filter.closed,
					pageNum: this.page,
					pageLimit: this.limit,
				});

				this.courseList = response.data.courseList; // 根据你的数据结构调整
				this.total = response.data.total;
			} catch (error) {
				console.error("An error occurred while fetching the dev list:", error);
			}
		},

		updateSemester() {
			if (this.createFormData.year && this.createFormData.season) {
				// 只取年份的四位数部分
				const year = this.createFormData.year.getFullYear ? this.createFormData.year.getFullYear() : this.createFormData.year;
				// 拼接年份和季节
				this.createFormData.semester = `${year}${this.createFormData.season}`;
				console.log(this.createFormData.semester);
			}
		},
		updateModifySemester() {
			if (this.modifyFormData.year && this.modifyFormData.season) {
				// 只取年份的四位数部分
				const year = this.modifyFormData.year.getFullYear ? this.modifyFormData.year.getFullYear() : this.modifyFormData.year;
				// 拼接年份和季节
				this.modifyFormData.semester = `${year}${this.modifyFormData.season}`;
				console.log(this.modifyFormData.semester);
			}
		},
		// 新增课程
		async submitCreateForm() {
			try {
				// 向数组中添加一个新的对象
				let postData = { // 直接使用对象，不是数组
					semester: this.createFormData.semester,
					courseNum: this.createFormData.courseNum,
					courseName: this.createFormData.courseName,
					createDate: this.createFormData.createDate,
					comment: this.createFormData.comment,
					closed: this.createFormData.closed,
				};
				console.log("1111", postData)
				const response = await this.$axios.post("/api/course/create", postData);
				console.log("User created:", response.data);
				this.createFormData = {
					// 重置表单数据
					year: null,
					season: '',
					semester: "",
					courseNum: "",
					courseName: "",
					createDate: "",
					comment: "",
					closed: "0",
				};
				this.createDialogVisible = false;
				this.fetchCourseList();
			} catch (error) {
				console.error("Error creating user:", error);
				// 这里你可以添加其他错误处理逻辑，比如显示一个错误消息给用户
			}
		},
		// 编辑课程
		async modifyClass(row) {
			let item = this.courseList.find((item) => item.id === row.id);
			console.log(item)
			const semester = item.semester;
			item.year = semester.slice(0, 4);  // 获取前4位作为年份
			item.season = semester.slice(4);   // 获取从第5位到最后的字符作为季节
			this.modifyFormData = {
				id: item.id,
				courseNum: item.courseNum,
				year: item.year,
				season: item.season,
				semester: item.semester,
				courseName: item.courseName,
				createDate: item.createDate,
				comment: item.comment,
				closed: String(item.closed),
			};

			this.modifyDialogVisible = true;
			this.currentId = row.id;
		},
		async submitModifyForm() {
			try {
				const postData = this.modifyFormData;
				const response = await this.$axios.post("/api/course/update", postData);
				this.modifyFormData = {
					// 重置表单数据
					id: "",
					year: null,
					season: "",
					courseNum: "",
					semester: "",
					courseName: "",
					createDate: "",
					comment: "",
					closed: "",
				};

				console.log(response);
				this.modifyDialogVisible = false;
				this.fetchCourseList();
			} catch (error) {
				console.error("Error creating user:", error);
				// 这里你可以添加其他错误处理逻辑，比如显示一个错误消息给用户
			}
		},
		// 删除课程
		async submitRemove() {
			try {
				const removeId = {
					ids: [this.selectRemoveId],
				};

				const response = await this.$axios.post("/api/course/delete", removeId);
				console.log("User removed:", response.data);

				console.log(response);
				this.removeDialogVisible = false;
				this.placeholder = {
					namePlaceholder: "请输入课程名",
				};
				this.fetchCourseList();
			} catch (error) {
				console.error("Error removing user:", error);
				// 这里你可以添加其他错误处理逻辑，比如显示一个错误消息给用户
			}
		},
		// 移除课程
		async removeClass(row) {
			let item = this.courseList.find((item) => item.id === row.id);
			this.placeholder = {
				namePlaceholder: item.courseName,
			};
			this.selectRemoveId = item.id;
			this.removeDialogVisible = true;
		},
		async batchRemoveConfirm() {
			this.removeBatchDialogVisible = true;
		},
		async batchRemove() {
			const list = this.multipleSelection.map((item) => item.id);
			try {
				const removeId = {
					ids: list,
				};

				const response = await this.$axios.post("/api/course/delete", removeId);
				console.log("User removed:", response.data);
				this.removeBatchDialogVisible = false;
				this.fetchCourseList();
			} catch (error) {
				console.error("Error removing user:", error);
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
			this.batchRemoveDisabled =
				this.multipleSelection.length == 0 ? true : false;
			if (this.multipleSelection.length != 0) {
				clearInterval(this.interval);
			} else {
				this.interval = setInterval(() => {
					this.fetchCourseList();
				}, 5000);
			}
			console.log(val);
		},
		// 进入资料 
		getData(row) {
			this.$router.push({ name: 'resourcemana', params: { courseId: row.id, courseName:row.courseName } })
		},

		// 进入课程简介页
		enterBrief(row) {
			this.$router.push({ name: 'classbrief', params: { courseId: row.id } })
		}
	},
});
</script>

<style scoped>
:deep .even-row {
	background-color: #f0f0f0;
	/* 设置偶数行的背景色 */
}

:deep .odd-row {
	background-color: #ffffff;
	/* 设置奇数行的背景色 */
}

.button-group {
	display: flex;
	/* background-color: yellow; */
	height: 4vh;
}

.el-button {
	height: 100%;
	margin-right: 6px;
}

.el-pagination {
	margin-top: 1vh;
	position: absolute;
	bottom: 1vh;
}

.dialog-information {
	margin-bottom: 30px;
	border: 1px solid #ccc;
	border-radius: 5px;
}

.dialog-information-text {
	margin: 10px;
	font-size: 15px;
}

:deep .el-dialog__header {
	margin-right: 0px;
}

:deep .el-dialog__body {
	padding-top: 16px;
}

/* 使表格中的文本可选中 */
:deep .el-table td {
	user-select: text;
}

.search {
	position: absolute;
	right: 2vw;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
